import { useSelector, shallowEqual } from "react-redux";
import TransportationPicto from "app/pages/.shared/TransportationPicto/TransportationPicto";

const mapStateToProps = state => {
	return {
		transportationTypes: state.ficheProduit.transportationTypes,
	};
};

const TransportationPictoContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <TransportationPicto {...props} {...stateProps} />;
};

export default TransportationPictoContainer;
